import React, { Fragment, memo, useContext, useEffect, useState } from "react";
import { AppContext } from "../../components/AppProvider";
import AllimList from "../../components/UI/Allim/AllimList";
import { ConfirmLayer } from "../../components/UI/Dialog";
import {
  PostApi1920,
  PostApi1921,
  PostApi1922,
} from "../../modules/network/padoPost";
import { _O } from "../../modules/utils";
import { NativeAction } from "../../modules/utils/HandleWs";
import { userHabit } from "../../modules/utils/UserHabit";
import { ScrollToTop } from "../common/ScrollToTop/ScrollToTop";
import { closeLayerFn, Container } from "../Layout";
import useTitle from "../../modules/hooks/useTitle";

export default memo(() => {
  const { userinfo, cfg, phonecfg, auth } = useContext(AppContext);
  useTitle("알림판_메인");
  const [loading, setLoading] = useState(true); // 스켈레톤 상태
  const [toDayAllims, setToDayAllims] = useState();
  const [histAllims, setHistAllims] = useState();

  const [allimList, setAllimList] = useState();

  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
    alrmNo: "",
  });

  const request1920 = () => {
    PostApi1920(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          setAllimList(res.result);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request1921 = (alrmNo, url, alrmType) => {
    PostApi1921(userinfo, cfg, phonecfg, alrmNo)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (alrmType === "PT") {
            _O.OpenMenu(url);
          } else {
            _O.OpenMenu(url);
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request1922 = alrmNo => {
    PostApi1922(userinfo, cfg, phonecfg, alrmNo)
      .then(res => {
        if (res.resultMsg === "SUCCESS" && res.result === 1) {
          // 목록갱신
          request1920();
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleCancelCB = () => {
    closeLayerFn($(".confirm-layer"));
  };

  const handleConfirmCB = () => {
    if (dialog.alrmNo) {
      request1922(dialog.alrmNo);
    } else {
      _O.Open("/membership/certification");
    }
  };

  const deleteAlrm = (title, msg, alrmNo) => {
    request1922(alrmNo);
  };

  const goToUrl = (alrmNo, url, alrmType) => {
    request1921(alrmNo, url, alrmType);
  };

  useEffect(() => {
    if (!auth) {
      return;
    }

    request1920();
  }, []);

  useEffect(() => {
    if (!allimList || (!Array.isArray(allimList) && !allimList.length > 0))
      return;

    const today = allimList.filter(m => m.date1 === "오늘");
    setToDayAllims(today);

    const hist = allimList.filter(m => m.date1 !== "오늘");
    setHistAllims(hist);

    setLoading(false);
  }, [allimList]);

  useEffect(() => {
    userHabit(phonecfg, "NB100");
    NativeAction(phonecfg, "statusColor", "#A5AEE4");
  }, [phonecfg.version]);

  return (
    <Fragment>
      <ScrollToTop />
      <Container Title="알림판" dark="dark" goToUrl="/">
        <div className="contents">
          <div className="sub-contents">
            <div className="device-link-contain type2">
              <AllimList
                title={{
                  className: "round-list purple",
                  text: "오늘의 알림",
                  iconClassName: "c4",
                }}
                loading={loading}
                allimList={toDayAllims ? toDayAllims : []}
                deleteAlrm={deleteAlrm}
                goToUrl={goToUrl}
              />
              <AllimList
                title={{
                  className: "round-list pink",
                  text: "미확인 알림",
                  iconClassName: "c5",
                }}
                loading={loading}
                allimList={histAllims ? histAllims : []}
                deleteAlrm={deleteAlrm}
                goToUrl={goToUrl}
              />
            </div>
          </div>
        </div>
      </Container>
      <ConfirmLayer
        title={dialog.title}
        msg={dialog.msg}
        handleConfirmCB={handleConfirmCB}
        handleCancelCB={handleCancelCB}
      />
    </Fragment>
  );
});
